// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"d72e429c","877":"0a759c01"}[chunkId] + ".chunk.css";
};